import S from './FleetSettingsStyles';
import useGetFleetId from '../../../API/hooks/useGetFleetId';
import useGetRole from '../../../API/hooks/useGetRole';
import CheckBox from '../../../components/common/CheckBox/CheckBox';
import useGetFleet from '../../../API/hooks/useGetFleetDetails';
import Select from '../../../components/common/Select/Select';
import { TIMEZONE_OFFSET_OPTIONS } from '../../../constants/TimeZones';

const WEEK_DAY_OPTIONS = [
  { label: 'Sunday', value: '0' },
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' },
];

function FleetSettings(): JSX.Element {
  const fleetId = useGetFleetId();
  const { isFleetViewer, isFleetManager } = useGetRole();
  const { data: fleetSettings } = useGetFleet(fleetId);

  const timezoneOffset = fleetSettings?.settings ? String(fleetSettings.settings.timezoneOffset) : '0';
  const weekStartDay = String(fleetSettings?.settings?.weekStartDay ?? 1);

  return (
    <S.Wrapper>
      <div className={!(isFleetViewer || isFleetManager) ? '' : 'hidden'}>
        <S.BlockContainer>
          <S.RowContainer>
            <h4>Fleet settings:</h4>
          </S.RowContainer>
          <S.RowContainer>
            <p className="time-zone-label">Start of week:</p>
            <div title="This setting is configured by an administrator in the admin panel.">
              <Select
                name="weekStartDay"
                value={weekStartDay}
                options={WEEK_DAY_OPTIONS}
                simple
                onChange={() => {}}
                disabled
              />
            </div>
          </S.RowContainer>
          <S.RowContainer>
            <p className="time-zone-label">Time zone:</p>
            <div title="This setting is configured by an administrator in the admin panel.">
              <Select
                name="timezoneOffset"
                value={timezoneOffset}
                options={TIMEZONE_OFFSET_OPTIONS}
                simple
                onChange={() => {}}
                disabled
              />
            </div>
          </S.RowContainer>
        </S.BlockContainer>
        <S.BlockContainer>
          <S.RowContainer>
            <h4>Fleet features status:</h4>
          </S.RowContainer>
          <S.RowContainer>
            <div title="This feature is configured by an administrator in the admin panel.">
              <CheckBox
                label="Live Video"
                state={fleetSettings?.features?.videoStreaming}
                onChange={() => {}}
                disabled
              />
            </div>
          </S.RowContainer>
          <S.RowContainer>
            <div title="This feature is configured by an administrator in the admin panel.">
              <CheckBox
                label="Custom VoD requests"
                state={fleetSettings?.features?.videoRecording}
                onChange={() => {}}
                disabled
              />
            </div>
          </S.RowContainer>
          <S.RowContainer>
            <div title="This feature is configured by an administrator in the admin panel.">
              <CheckBox
                label="Alert Video Upload"
                state={fleetSettings?.features?.alertVideoUpload}
                onChange={() => {}}
                disabled
              />
            </div>
          </S.RowContainer>
        </S.BlockContainer>
      </div>
      <div className={(isFleetViewer || isFleetManager) ? '' : 'hidden'}>
        <S.RowContainer>
          <p className="message error">No permissions to see or change setting!</p>
        </S.RowContainer>
      </div>
    </S.Wrapper>
  );
}

export default FleetSettings;
